import { Component, ViewContainerRef, ViewChild, HostListener, OnInit } from '@angular/core'
import { CtrlBaseComponent } from '../ctrl-base.component';
import { CtContentItemComponent } from "../ct-content-item/ct-content-item.component";
import { Color } from '../../enums/color.enum';
import { breakpoints } from '../../environments/environment.breakpoints';

@Component({
  selector: 'ct-tab',
  templateUrl: './ct-tab.component.html',
  styleUrls: ['./ct-tab.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()'
  }
})
export class CtTabComponent extends CtrlBaseComponent implements OnInit {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  private selectedTab: CtContentItemComponent;
  public isMedium: boolean;
  public isSmall: boolean;
  public isExtraSmall: boolean;

  constructor() {
    super();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  ngOnInit() {
    super.ngOnInit();
    this.checkScreenSize();
  }

  private checkScreenSize() : void {
    const screenWidth = window.innerWidth;
    this.isMedium = screenWidth >= breakpoints.L;
    this.isSmall = screenWidth < breakpoints.L && screenWidth > breakpoints.M;
    this.isExtraSmall = screenWidth <= breakpoints.M && screenWidth > breakpoints.S;
  }

  ngAfterViewInit() {
    this.paintChildren(this.getMetaData(), this.target).forEach(x => x.setHidden(true));
    
    if (this.childElements.length > 0) {
      let selectedTab = this.getMetadataPropertyValue('_selectedTab');
      this.setSelectedTab(selectedTab);
    }
  }

  public changeTab(newTabId: string, triggerEvent: boolean = true): void {
    let child = this.getTabs().find(x => newTabId === x.getId());
    
    if (child && child !== this.getSelectedTab()) {
      this.setSelectedTab(child);

      if (triggerEvent)
        child.event2('onClick');
    }
  }

  public getContentItemColor(contentItem : CtContentItemComponent): string {
    switch(contentItem.getColor()) {
      case Color.Danger:
        return 'th-text-alert ';
      case Color.Primary:
        return 'th-text-main';
      case Color.Secondary:
        return 'th-text-secondary';
      default:
        return 'th-text-main';
    }
  }

  getSelectedTab(): CtContentItemComponent { return this.selectedTab }
  getTabs(): CtContentItemComponent[] { return <CtContentItemComponent[]> this.childElements }

  setSelectedTab(selectedTab: string | CtContentItemComponent): void {
    if (typeof(selectedTab) === 'string')
      this.changeTab(selectedTab, false);

    else if (!selectedTab && this.childElements.length > 0)
      this.setSelectedTab(<CtContentItemComponent> this.childElements[0]);

    else if (selectedTab instanceof CtContentItemComponent && selectedTab !== this.selectedTab) {
      if (this.selectedTab)
        this.selectedTab.setHidden(true);
      this.selectedTab = selectedTab;
      this.selectedTab.setHidden(false);
      this.event2('onTabChange');
    }
  }
}

